import React, { memo } from 'react';
import styles from './FloorTableRows.module.scss';
import classNames from 'classnames';
import getName from '../../../../../../helpers/getName';

const FloorTableRows = ({ rowData, clickHighlighted, rowOnClick }) => {
  return (
    <>
      {rowData.map((entry) => (
        <div
          className={styles.floorsTableRow}
          key={entry.id}
          onClick={() => rowOnClick(entry)}
        >
          <div className={styles.rowCell}>
            <div
              className={classNames(styles.blockHighlight, styles.cursor)}
              onClick={() => clickHighlighted && clickHighlighted(entry)}
            >
              {entry.name}
            </div>
          </div>
          <div className={styles.rowCell}>
            <div
              className={styles.blockHighlight}
              style={{ textAlign: 'center' }}
            >
              {entry.number}
            </div>
          </div>
          <div className={styles.rowCell}>{entry.area}</div>
          <div className={styles.rowCell}>
            {entry.tenant?.name || getName(entry.tenant)}
          </div>
          <div className={styles.rowCell}>
            {entry.landLord?.name || getName(entry.landLord)}
          </div>
          <div className={styles.rowCell}>{entry.status?.name}</div>
        </div>
      ))}
    </>
  );
};

export default memo(FloorTableRows);
